// src/services/feedbackService.js
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  query,
  orderBy,
  limit,
  serverTimestamp,
} from 'firebase/firestore';
import { db, auth } from '../firebase';

const feedbackService = {
  async createFeedback({ type, description, userName, userEmail }) {
    try {
      const user = auth.currentUser;
      if (!user) return { success: false, error: 'Non authentifié' };

      await addDoc(collection(db, 'feedbacks'), {
        userId: user.uid,
        userEmail: userEmail || user.email || '',
        userName: userName || '',
        type,
        description,
        page: window.location.pathname,
        userAgent: navigator.userAgent,
        status: 'new',
        createdAt: serverTimestamp(),
      });

      return { success: true };
    } catch (err) {
      console.error('feedbackService.createFeedback error:', err);
      return { success: false, error: err.message };
    }
  },

  async getFeedbacks(max = 30) {
    try {
      const q = query(collection(db, 'feedbacks'), orderBy('createdAt', 'desc'), limit(max));
      const snap = await getDocs(q);
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    } catch (err) {
      console.error('feedbackService.getFeedbacks error:', err);
      return [];
    }
  },

  async updateFeedbackStatus(feedbackId, status) {
    try {
      await updateDoc(doc(db, 'feedbacks', feedbackId), { status });
      return { success: true };
    } catch (err) {
      console.error('feedbackService.updateFeedbackStatus error:', err);
      return { success: false, error: err.message };
    }
  },
};

export default feedbackService;
